import { getLensDisplayName } from "./lens";

export const LOCAL_CART_KEY = 'guest_cart';

export const getLocalCart = () => {
  try {
    const data = localStorage.getItem(LOCAL_CART_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
};

export const replaceLocalCart = (items) => {
  try {
    if (!Array.isArray(items) || items.length === 0) {
      localStorage.removeItem(LOCAL_CART_KEY);
      return [];
    }
    localStorage.setItem(LOCAL_CART_KEY, JSON.stringify(items));
    return items;
  } catch {
    return Array.isArray(items) ? items : [];
  }
};

// Строим название продукта из полей lens/camera/serial_number (как в Asset.jsx и Product.jsx)
const buildProductName = (product) => {
  const parts = [
    product.camera?.brand,
    product.camera?.model_name,
    getLensDisplayName(product.lens),
    product.serial_number ? `#${product.serial_number}` : null,
  ].filter(Boolean);
  return parts.length > 0 ? parts.join(' ') : (product.name || product.title || 'Product');
};

const isDefined = (value) => value !== undefined && value !== null && value !== '';

const pickFirstDefined = (...values) => {
  const match = values.find(isDefined);
  return match ?? 0;
};

export const resolvePriceTier = (product) => {
  if (product?.access_type === 'free') {
    return undefined;
  }
  if (product?.price_tier === 'full' || product?.price_tier === 'grids_only') {
    return product.price_tier;
  }

  const hasNonGridAssets = Array.isArray(product?.assets)
    && product.assets.some((asset) => asset.asset_type?.is_grid === false);

  return (hasNonGridAssets && product?.full_price != null) ? 'full' : 'grids_only';
};

export const addToLocalCart = (product) => {
  const cart = getLocalCart();
  const exists = cart.find((item) => item.product === product.id);
  if (exists) return cart;

  const isFreeProduct = product?.access_type === 'free';
  const priceTier = resolvePriceTier(product);
  const price = isFreeProduct
    ? 0
    : priceTier === 'full'
      ? pickFirstDefined(product.full_price, product.price)
      : pickFirstDefined(product.grids_price, product.price);
  const discountedPrice = isFreeProduct
    ? 0
    : priceTier === 'full'
      ? pickFirstDefined(
        product.full_discounted_price,
        product.full_price,
        product.discounted_price,
        product.price,
      )
      : pickFirstDefined(
        product.grids_discounted_price,
        product.grids_price,
        product.discounted_price,
        product.price,
      );

  const item = {
    id: `local_${product.id}`,
    product: product.id,
    product_name: buildProductName(product),
    ...(product.access_type ? { access_type: product.access_type } : {}),
    ...(priceTier ? { price_tier: priceTier } : {}),
    price,
    discounted_price: discountedPrice,
    slug: product.slug || '',
    quantity: 1,
    isLocal: true,
  };

  return replaceLocalCart([...cart, item]);
};

export const removeFromLocalCart = (productId) => {
  const cart = getLocalCart();
  const updated = cart.filter((item) => item.product !== productId && item.id !== productId);
  return replaceLocalCart(updated);
};

export const clearLocalCart = () => {
  localStorage.removeItem(LOCAL_CART_KEY);
};

export const isInLocalCart = (productId) => {
  const cart = getLocalCart();
  return cart.some((item) => item.product === productId);
};
